// components/SessionExpiredDialog.js

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const SessionExpiredDialog = ({ open, onLogin }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-description"
    >
      <DialogTitle
        id="session-expired-title"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <LockIcon color="error" />
        Session Expired
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="session-expired-description">
          Your session has expired. Please login again to continue using the platform.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" fullWidth onClick={onLogin}>
          Login Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
